const API_BASE = process.env.REACT_APP_API_URL || '';

function getToken() {
  return localStorage.getItem('heb_family_token') || '';
}

async function apiFetch(path, options = {}) {
  const token = getToken();
  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
      ...(options.headers || {})
    }
  });
  if (res.status === 403) {
    localStorage.removeItem('heb_family_token');
    window.location.reload();
    throw new Error('Unauthorized');
  }
  return res.json();
}

export async function verifyToken(token) {
  const res = await fetch(`${API_BASE}/api/auth/verify`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }
  });
  return res.ok;
}

// Items
export const getItems = (params = '') => apiFetch(`/api/items${params ? '?' + params : ''}`);
export const createItem = (data) => apiFetch('/api/items', { method: 'POST', body: JSON.stringify(data) });
export const updateItem = (id, data) => apiFetch(`/api/items/${id}`, { method: 'PUT', body: JSON.stringify(data) });
export const deleteItem = (id) => apiFetch(`/api/items/${id}`, { method: 'DELETE' });

// Pantry
export const getPantry = (search = '') => apiFetch(`/api/pantry${search ? '?search=' + encodeURIComponent(search) : ''}`);
export const getLowStock = () => apiFetch('/api/pantry/low-stock');
export const usePantryItem = (id, quantity) => apiFetch(`/api/pantry/${id}/use`, { method: 'POST', body: JSON.stringify({ quantity }) });
export const restockPantryItem = (id, quantity) => apiFetch(`/api/pantry/${id}/restock`, { method: 'POST', body: JSON.stringify({ quantity }) });

// Shopping List
export const getList = () => apiFetch('/api/list');
export const generateList = () => apiFetch('/api/list/generate', { method: 'POST' });
export const addToList = (itemId, quantity) => apiFetch('/api/list/items', { method: 'POST', body: JSON.stringify({ itemId, quantity }) });
export const updateListItem = (index, data) => apiFetch(`/api/list/items/${index}`, { method: 'PUT', body: JSON.stringify(data) });
export const removeFromList = (index) => apiFetch(`/api/list/items/${index}`, { method: 'DELETE' });
export const submitOrder = (mode) => apiFetch('/api/list/submit', { method: 'POST', body: JSON.stringify({ mode }) });
export const clearList = () => apiFetch('/api/list/clear', { method: 'POST' });

// Meals
export const getMeals = () => apiFetch('/api/meals');
export const createMeal = (data) => apiFetch('/api/meals', { method: 'POST', body: JSON.stringify(data) });
export const updateMeal = (id, data) => apiFetch(`/api/meals/${id}`, { method: 'PUT', body: JSON.stringify(data) });
export const deleteMeal = (id) => apiFetch(`/api/meals/${id}`, { method: 'DELETE' });
export const addMealToList = (id) => apiFetch(`/api/meals/${id}/add-to-list`, { method: 'POST' });
export const createMealFromUrl = (url) => apiFetch('/api/meals/from-url', { method: 'POST', body: JSON.stringify({ url }) });

// UPC Lookup
export const lookupUPC = (code) => apiFetch(`/api/lookup/upc?code=${encodeURIComponent(code)}`);

// Orders
export const getPendingOrders = () => apiFetch('/api/orders/pending');
export const confirmOrder = (id) => apiFetch(`/api/orders/${id}/confirm`, { method: 'POST' });
export const cancelOrder = (id) => apiFetch(`/api/orders/${id}/cancel`, { method: 'POST' });
